<template>
  <div class="card">
    <h5 class="card-header text-truncate w-100">
      Cancelación por mes
    </h5>
    <div class="card-body pb-0">
      <div id="graficaCancelados">
        <apexchart
          class="apex-charts"
          height="350"
          dir="ltr"
          :series="series"
          :options="chartOptions"
        ></apexchart>
      </div>
      
      <br>

      <div class="row mb-4">
        <div class="col-md-4">
          <div class="row mb-4">
            <label class="col-sm-5 col-5 col-form-label text-truncate" title="Mes inicial">
              Mes inicial
            </label>
            <div class="col-sm-7 col-7">
              <Datepicker
                ref="mesInicial"
                v-model="mesInicial"
                class="form-control"
                :class="{
                  'bg-white': $store.state.layout.layoutMode == 'light',
                }"
                :minimumView="'month'"
                :maximumView="'month'"
                :inputFormat="'MMMM yyyy'"
              />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row mb-4">
            <label class="col-sm-5 col-5 col-form-label text-truncate" title="Mes final">
              Mes final
            </label>
            <div class="col-sm-7 col-7">
              <Datepicker
                ref="mesFinal"
                v-model="mesFinal"
                class="form-control"
                :class="{
                  'bg-white': $store.state.layout.layoutMode == 'light',
                }"
                :minimumView="'month'"
                :maximumView="'month'"
                :inputFormat="'MMMM yyyy'"
              />
            </div>
          </div>
        </div>

        <div class="col-md-2 col-6">
          <button
            class="btn btn-outline-success btn-block"
            @click="actualizar()"
          >
            <i class="mdi mdi-refresh"></i>
          </button>
        </div>

        <div class="col-md-2 col-6">
          <button
            class="btn btn-light btn-block text-truncate"
            title="Cancelados"
            @click="verContratosCancelados()"
          >
            <i class="mdi mdi-format-list-bulleted"></i>
            Cancelados
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReporteSrv from '@/services/ReporteSrv.js'
import Datepicker from 'vue3-datepicker'
import moment from 'moment'

export default {
  name: 'WCancelacion',
  components: {
    Datepicker
  },
  data() {
    return {
      mesInicial: '01/2018',
      mesFinal: '12/2019',
      totales: [],

      // grafica
      series: [
        {
          name: "Contratos cancelados",
          data: [],
        }
      ],
      // configuracion de la grafica
      chartOptions: {
        chart: {
          height: 350,
          type: "area",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: true,
          },
        },
        markers: {
          size: 4,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        colors: ["#f56e6e"],
        title: {
          text: "Contratos cancelados",
          align: "left",
          style: {
            fontWeight: 500,
          },
        },
        yaxis: {
          min: 0
        },
        xaxis: {
          categories: [
            // "Ene",
            // "Feb",
            // "Mar",
            // "Apr",
            // "May",
            // "Jun",
            // "Jul",
            // "Aug",
            // "Sep",
            // "Oct",
            // "Nov",
            // "Dic"
          ],
          // title: {
          //   text: "Meses",
          // },
          tickAmount: 10,
          tooltip: {
            enabled: false,
          }
        },
      }
      // fin de la configuracion de la grafica
    }
  },

  created() {
    var self = this
    
    let hoy = new Date()
    self.mesFinal = hoy
    var anio = hoy.getFullYear();
    var mes = hoy.getMonth();
    var dia = hoy.getDate();

    var menosAnios = 2
    if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i) || window.innerWidth <= 780) {
      menosAnios = 1
    }

    self.mesInicial = new Date(anio - menosAnios, mes, dia);
      
    self.actualizar()
    
    window.addEventListener('resize', function(event){
      self.dibujarGrafica(self.totales)
    })
  },

  mounted: function(){
    iu.spinner.mostrar('#graficaCancelados')
  },

  methods: {
    actualizar() {
      var self = this

      iu.spinner.mostrar('#graficaCancelados')
      var mesInicial = self.formatoFecha(self.mesInicial,'MM/YYYY')
      var mesFinal = self.formatoFecha(self.mesFinal,'MM/YYYY')

      ReporteSrv.contratosCanceladosPorMes(mesInicial,mesFinal,true).then(response => {
        self.totales = response.data
        self.dibujarGrafica(self.totales)
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (error) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje):null
        console.log(error)
      }).finally(fin => {
        iu.spinner.ocultar('#graficaCancelados')
      })
    },
    dibujarGrafica(totales) {
      var self = this, cont = 0

      let categories = []
      self.series[0].data = []
      
      totales.forEach((t, index) => {
        if(cont == 0){
          categories.push('')
          cont = 1
        } else {
          let fecha = self.formatoFecha(t.mes, 'MMM YY')
          categories.push(fecha)
          cont = 0
        }
        self.series[0].data.push(t.total)
      })

      self.chartOptions = {
        chart: {
          height: 350,
          type: "area",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: true,
          },
        },
        markers: {
          size: 4,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        colors: ["#f56e6e"],
        title: {
          text: "Contratos cancelados",
          align: "left",
          style: {
            fontWeight: 500,
          },
        },
        yaxis: {
          min: 0
        },
        xaxis: {
          categories: categories,
          // title: {
          //   text: "Meses",
          // },
          tickAmount: 50,
          tooltip: {
            enabled: false,
          }
        },
      }
    },
    
    formatoFecha(mt, formato = 'MMMM YYYY') {
      return moment(mt).locale('es-mx').format(formato)
    },

    verContratosCancelados: function(id) {
      var self = this
      
      let mesInicial = self.formatoFecha(self.mesInicial,'MM-YYYY')
      let mesFinal = self.formatoFecha(self.mesFinal,'MM-YYYY')

      self.$router.push({ name: 'cancelacionContratos', query: { mesInicial, mesFinal } })
    }
  },
};
</script>

<style scoped>
.btn-block {
  display: block;
  width: 100%;
}
</style>